module.exports = __webpack_public_path__ + "assets/img/one.a65a31a6.png";